import styled from 'styled-components'
import {Button, Button as IconButton} from '~/src/design-system/Primitives'

export const EmptyStateContainerAndText = styled.div`
  text-align: center;
  padding: var(--space-16) var(--space-8);
  color: var(--neutral-600);
  font-size: 1rem;
  line-height: 24px;
`

export const EmptyStateTitle = styled.p`
  color: var(--neutral-800);
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 var(--space-2) 0;
`

export const EmptyStateText = styled.p`
  color: var(--neutral-600);
  font-size: 1rem;
  margin: 0 0 var(--space-6) 0;
`

export const ReusuableHeaderText = styled('h2')`
  color: var(--neutral-800);
  font-size: 1rem;
  font-weight: 600;
`

export const SoloSubTabText = styled('div')`
  color: #1f1f1f;
  font-size: 1rem;
  font-weight: 600;
  line-height: 20px;
`
//for headers like Company Information, Site Information, etc.
export const HeaderAndButtonContainerBorder = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--neutral-300);
  padding: 10px var(--space-5);
`

export const IconButtonStyled = styled(IconButton).attrs({variant: 'ghost' as const})<{
  $isActive: boolean
}>`
  /* Match the adjacent search/filter field height (--input-height-md = 44px) so the
     toolbar filter-toggle lines up with the field beside it (design review). */
  width: var(--input-height-md);
  height: var(--input-height-md);
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.$isActive ? 'var(--brand-cta)' : 'var(--neutral-600)')};

  &:hover {
    background: var(--neutral-100);
    border-color: var(--brand-cta);
    color: var(--brand-cta);
  }
`
export const BackButtonStyled = styled(Button).attrs({variant: 'secondary' as const})`
  border: 1px solid var(--neutral-300);
  border-radius: var(--radius-sm);
  width: 40px;
  height: 40px;
  color: var(--neutral-600);

  &:hover {
    background: var(--neutral-100);
    border-color: var(--brand-cta);
    color: var(--brand-cta);
  }
`

export const PageTitle = styled('h1')`
  color: var(--neutral-800);
  font-family: 'Open Sans';
  font-size: 24px;
  font-weight: 700;
  margin: 0;
`

export const PageTitleContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: var(--space-4);
  /* 32px — consistent header→body gap matching the rest of the app
     (was a one-off 45px). */
  margin-bottom: var(--space-8);
`
